import * as React from "react";
import { IconProps } from "../types";

const ThumbsDownOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="19"
        height="18"
        fill="none"
        ref={forwardedRef}
        viewBox="0 0 19 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.75 10.506C5.75 10.986 5.923 11.45 6.236 11.813L10.5 16.75C11.354 16.323 11.75 15.322 11.42 14.426L10.25 11.25H14.652C15.965 11.25 16.921 10.007 16.585 8.738L15.394 4.238C15.162 3.361 14.368 2.75 13.461 2.75H7.75C6.645 2.75 5.75 3.645 5.75 4.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.75 2.75H3.25C2.69772 2.75 2.25 3.19772 2.25 3.75V10.25C2.25 10.8023 2.69772 11.25 3.25 11.25H4.75C5.30228 11.25 5.75 10.8023 5.75 10.25V3.75C5.75 3.19772 5.30228 2.75 4.75 2.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default ThumbsDownOutlineIcon;
